import React, { Component } from 'react';
import WorkItem from '../../components/WorkItem';
import animations from './animations';
import { isMobile } from "react-device-detect";

class Work extends Component {

    constructor(props) {
        super(props);

        this.state = {
            position: 0,
            containers: [],
            buttons: [],
            inProgress: false
        };

        const exetelDesc = `I was the sole frontend engineer for Exetel until the acquisition by Superloop. Doing the job of a whole team solo, I rebuilt the frontend for the entire company on my own including all websites and the customer portal.`;
        const exetelSkills = 'React, GraphQL, Tailwind CSS, Gatsby, Management'

        this.items = [
            {
                title: 'ZenSim',
                image: 'work-zensim.jpg',
                url: 'https://www.zensim.com.au/',
                description: `I was brought on to both design & build the entire frontend for ZenSim from scratch including both the website and app.`,
                skills: 'React, React Native, Typescript, GraphQL, Tailwind CSS, Gatsby, UI/UX Design'
            },
            {
                title: 'ZenSim App',
                image: 'work-zensim-app.jpg',
                url: 'https://www.zensim.com.au/zensim-app/',
                description: `I was brought on to both design & build the entire frontend for ZenSim from scratch including both the website and app.`,
                skills: 'React, React Native, Typescript, GraphQL, Tailwind CSS, Gatsby, UI/UX Design'
            },
            {
                title: 'Superloop',
                image: 'work-superloop.jpg',
                url: 'https://www.superloop.com',
                description: `I was tasked with building and managing an engineering team of four engineers, integrating new products & tech into the Superloop frontend, facilitating the full company rebrand across all customer facing projects.`,
                skills: 'React, GraphQL, Tailwind CSS, Gatsby, GSAP Animation'
            },
            {
                title: 'Hostelify',
                image: 'work-hostelify.jpg',
                url: 'https://hostelify.app',
                description: 'Hostelify wanted something clean, modern and super performant so I built this site in Gatsby combined with custom SVG illustrations for high performance and a modern vibe.',
                skills: 'React, Gatsby, GSAP Animation, UI/UX Design'
            },
            {
                title: 'Exetel Residential',
                image: 'work-exetel-2.jpg',
                url: 'https://exetel.com.au',
                description: exetelDesc,
                skills: exetelSkills
            },
            {
                title: 'My Exetel Portal',
                image: 'work-my-exetel.jpg',
                url: 'https://my.exetel.com.au',
                description: exetelDesc,
                skills: exetelSkills
            },
            // {
            //     title: 'Exetel Business',
            //     image: 'work-exetel-business.jpg',
            //     url: 'https://business.exetel.com.au',
            //     description: exetelDesc,
            //     skills: exetelSkills
            // }
        ];
    }

    componentDidMount() {
        this.setState({
            containers: this.compileContainers(),
            buttons: this.compileButtons()
        });
    }

    handleChange(nextPos) {
        if (!this.state.inProgress) {
            this.setInProgress();
            animations.handleChange(this.container, this.state.position, nextPos, this.pointer, () => {
                this.setState({
                    position: nextPos,
                    inProgress: false
                });
            });
        }
    }

    setInProgress() {
        this.setState({
            inProgress: true
        });
    }

    calcNextPos() {
        if (this.state.position === (this.items.length - 1)) {
            return 0;
        }

        return this.state.position + 1;
    }

    compileContainers() {
        return this.items.map((value, key) => {
            return (
                <WorkItem
                    {...value}
                    key={key}
                    id={'work-item-' + key}
                    handleMouseEnter={animations.handleMouseEnter.bind(this)}
                    handleMouseLeave={animations.handleMouseLeave.bind(this)}
                />
            );
        });
    }

    compileButtons() {
        return this.items.map((value, key) => {
            return (
                <div className={`button ${key === this.state.position ? 'active' : ''}`}
                    key={key}
                    id={'work-btn-' + key}
                    onClick={() => this.handleChange(key)}
                />
            );
        });
    }

    getNavHand() {
        return (
            <div
                className="do-stuff"
                onClick={() => this.handleChange(this.calcNextPos())}
            >
                <div className="pointer" ref={el => this.pointer = el}>
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96.88 82.52">
						<g id="Layer_2" data-name="Layer 2">
							<g id="Layer_1-2" data-name="Layer 1">
								<polygon className="pointer-bg" points="11.82 24.43 36.37 3.42 42.23 3.42 46.75 9.53 37.47 21.74 37.59 24.43 89.75 24.43 93.78 29.44 90.61 37.62 55.79 38.6 63.85 41.26 65.32 47.39 60.56 52.16 58.6 52.16 50.17 52.16 58.36 53.38 60.8 57.9 59.7 63.88 55.43 66.2 50.05 66.2 55.43 69.5 57.14 72.68 55.55 76.34 52.8 80.01 23.42 79.4 10.72 75.24 1.79 58.88 4.12 30.41 11.82 24.43"/>
								<path d="M50.12,82.52a9.31,9.31,0,0,0,9.27-9.27A9.56,9.56,0,0,0,57.76,68a9.11,9.11,0,0,0,5.81-8.56,9.53,9.53,0,0,0-1.63-5.29,9.33,9.33,0,0,0,4.58-13.25H87.61a8.84,8.84,0,0,0,6.52-2.75,9.26,9.26,0,0,0,2.75-6.52h0a9.31,9.31,0,0,0-9.27-9.27H40l6.41-6.42A9.38,9.38,0,0,0,47.57,4.08a9,9,0,0,0-6.41-4,9.53,9.53,0,0,0-7.34,2l-22.92,19A29.87,29.87,0,0,0,0,44.21V56A26.43,26.43,0,0,0,26.49,82.52Zm-39-11A21.77,21.77,0,0,1,4.69,56V44.21a25.6,25.6,0,0,1,9.16-19.56l23-18.94a4.69,4.69,0,0,1,3.66-1,4.62,4.62,0,0,1,3.26,2,5,5,0,0,1,.82,2.64,4.8,4.8,0,0,1-1.43,3.37l-7.54,7.64a3.92,3.92,0,0,0-.81,4.27,4,4,0,0,0,3.67,2.45h49.1a4.5,4.5,0,0,1,4.68,4.48h0A4.68,4.68,0,0,1,91,34.84a4.46,4.46,0,0,1-3.26,1.33H53.89a2.34,2.34,0,1,0,0,4.68h4.58a4.59,4.59,0,0,1,4.59,4.69,4.65,4.65,0,0,1-4.59,4.68H49.71a2.35,2.35,0,0,0,0,4.69H54.3a4.59,4.59,0,0,1,4.58,4.69,4.65,4.65,0,0,1-4.58,4.68H45.43a2.35,2.35,0,0,0,0,4.69H50a4.59,4.59,0,0,1,0,9.17H26.59A22.89,22.89,0,0,1,11.1,71.52Z"/>
							</g>
						</g>
					</svg>
                </div>
                <div className="target" />
            </div>
        );
    }

    render() {
        return (
            <section className="work" {...this.props}>
				<div className="trigger" />
                <div className="work-inner">
					{isMobile ?
						<div className="title-mobile">
							<h2 dangerouslySetInnerHTML={{__html: this.items[this.state.position].title}} className="text-center text-lg-left sub-heading" />
						</div>
					: ''}
					<div className="item-container" ref={el => this.container = el}>
						{this.state.containers}
					</div>
					<div className="nav">
						{this.state.buttons}
						{this.getNavHand()}
					</div>
                    {isMobile ?
                        <div className="blurb">
                            <p dangerouslySetInnerHTML={{__html: this.items[this.state.position].description}} />
                            <p dangerouslySetInnerHTML={{__html: this.items[this.state.position].skills}} className='font-weight-bold' />
                        </div>
                    : ''}
                </div>
            </section>
        );
    }

}

export default Work;


// WEBPACK FOOTER //
// ./src/js/views/Work/Work.js